import React from 'react'

import photo from "../../img/portrait.jpg";
import { IoIosPin } from "react-icons/io";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { IoMailOutline } from "react-icons/io5";

import desktopVideo from '../../video/v720.m4v'
import tabletVideo from '../../video/v480.m4v'
import mobileVideo from '../../video/v480.m4v'




import {
    ContactContainer,
    ContactsTextWrapper,
    ContactWrapper,
    ContactRow,

    ContactsH1,
  
    ContactInfoContainer,
    ContactElement,

    ContactCard,
    ContactBottom,
    ContactsPortrait,
    ContactCardRight,
    ContactCardLeft,
    ContactElementText,
    RequestBg,
    RequestVideoBg,
    RequestContainerWrap,
    RequestContainer
} from './RequestElements'
import { Fa500Px } from 'react-icons/fa';
import { WaveContainer } from '../LandingSection/LandingElements';


const RequestSection = () => {
    const getVideoSrc = width => {
        if (width >= 1080) return desktopVideo;
        if (width >= 720) return tabletVideo;
        return mobileVideo;
      };
    
      const video = getVideoSrc(window.innerWidth);

    return (
        <div id="contact">
            <RequestContainer>
                <RequestBg>
                        <RequestVideoBg playsInline autoPlay loop muted src={video} type="video/mp4"/>
                </RequestBg>
               <RequestContainerWrap>
               <ContactsTextWrapper>
                    <ContactsH1>Process Server Request Form
                    </ContactsH1>
                </ContactsTextWrapper>
                <ContactWrapper>
                    <ContactRow>
                        <ContactInfoContainer>
                           <ContactCard>
                                <ContactCardRight>
                                    <ContactsPortrait src={photo}/>
                                </ContactCardRight>
                                <ContactCardLeft>
                                    <ContactElement>
                                        <h2>
                                            Luis Torres
                                        </h2>
                                    </ContactElement>
                                    <ContactElement>
                                        <IoIosPin style={{fontSize:' 1.5rem', marginRight: '1rem'}}/>
                                        <ContactElementText>
                                        123 Liberty Avenue, Suite 400, Springfield
                                        </ContactElementText>
                                    </ContactElement>

                                    <ContactElement>
                                        <IoPhonePortraitOutline style={{fontSize:' 1.5rem', marginRight: '1rem'}}/>
                                        <ContactElementText>
                                        619-960-5293
                                            
                                        </ContactElementText>
                                    </ContactElement>

                                    <ContactElement>
                                        <IoMailOutline style={{fontSize:' 1.5rem', marginRight: '1rem'}}/>
                                        <ContactElementText>
                                        TrustedProcessServicess@gmail.com

                                        </ContactElementText>
                                        
                                    </ContactElement>
                                    <ContactElement>
                                        <IoMailOutline style={{fontSize:' 1.5rem', marginRight: '1rem'}}/>
                                       <ContactElementText>
                                        LuisTorres@TrustedProcessServices.com
                                       </ContactElementText>
                                        
                                    </ContactElement>

                                </ContactCardLeft>
                           </ContactCard>
                            <ContactBottom></ContactBottom>
                           
                        </ContactInfoContainer>
                    </ContactRow>

                </ContactWrapper>
               </RequestContainerWrap>
            </RequestContainer>
        </div>
    )
}

export default RequestSection
